export class CompanyModel {
  public code: string = null;
  public label: string = null;
  public id: number = null;
  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
